import { JiraSoftwareIcon, JiraServiceManagementIcon, JiraWorkManagementIcon, JiraProductDiscoveryIcon, ConfluenceIcon } from '@atlaskit/logo';
const JSW_KEY = 'jira-software.ondemand';
const JSM_KEY = 'jira-servicedesk.ondemand';
const JWM_KEY = 'jira-core.ondemand';
const JPD_KEY = 'jira-product-discovery';
const CONFLUENCE_KEY = 'confluence.ondemand';
export const PRODUCT_NAME_BY_KEY = {
    [JSW_KEY]: 'Jira Software',
    [JSM_KEY]: 'Jira Service Management',
    [JWM_KEY]: 'Jira Work Management',
    [JPD_KEY]: 'Jira Product Discovery',
    [CONFLUENCE_KEY]: 'Confluence'
};
export const PRODUCT_ICON_BY_KEY = {
    [JSW_KEY]: JiraSoftwareIcon,
    [JSM_KEY]: JiraServiceManagementIcon,
    [JWM_KEY]: JiraWorkManagementIcon,
    [JPD_KEY]: JiraProductDiscoveryIcon,
    [CONFLUENCE_KEY]: ConfluenceIcon
};
//# sourceMappingURL=models.js.map